// extracted by mini-css-extract-plugin
export default {"container":"styles_container__AQP1-","textBox":"styles_textBox__3d6wI","btncontainer":"styles_btncontainer__9HsYK"};